import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.allocate.comprehensive;
// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//allocate plan
const allocatePlan = async (request) => {
    let response;
    await axios.post(baseUrl + 'allocate-comprehensive', request, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}
//get all
const getAll = async () => {
    let response;
    await axios.get(baseUrl+'get-all-comprehensive-policies/0/100')
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

export default {
    getAll,allocatePlan
}
